<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import HeaderComponent from '@/components/navigation/HeaderComponent.vue'
import SidebarComponent from '@/components/navigation/SidebarComponent.vue'
import { TypographyComponent } from '@/ui-library'

const router = useRoute()
const actionButtons = [
  {
    regex: /^\/stores\/?$/,
    to: '/stores/create',
    text: 'Add Advertiser',
  },
]
const activeButton = computed(() => actionButtons.find((btn) => router.path.match(btn.regex)))
</script>

<template>
  <header-component v-if="$route.path !== '/login'">
    <template #action-buttons>
      <router-link v-if="activeButton" :to="activeButton.to" class="action-link">
        <el-icon color="#fff">
          <plus-icon />
        </el-icon>
        <TypographyComponent variant="headline-medium" color="#fff">
          {{ activeButton.text }}
        </TypographyComponent>
      </router-link>
    </template>
  </header-component>
  <sidebar-component />
  <div class="content">
    <main>
      <router-view />
    </main>
  </div>
</template>
<style scoped lang="scss">
.action-link {
  &:deep(* + *) {
    margin-top: initial;
  }

  margin-top: 0;
  text-decoration: none;

  h2 {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }

  span {
    margin-top: 0;
  }
}
</style>
